import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../../shared/utils/apiConfig';

// Fetch clinic doctors
export const fetchClinicDoctors = createAsyncThunk(
    'clinicDoctors/fetchClinicDoctors',
    async (params = {}, { rejectWithValue }) => {
        try {
            const query = new URLSearchParams();
            if (params.page) query.set('page', params.page);
            if (params.per_page) query.set('per_page', params.per_page);
            const qs = query.toString();
            const url = qs ? `/clinics/my_doctors?${qs}` : '/clinics/my_doctors';
            const response = await apiClient.get(url);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'فشل في جلب قائمة الأطباء');
        }
    }
);

// Invite doctor to clinic
export const inviteDoctor = createAsyncThunk(
    'clinicDoctors/inviteDoctor',
    async (inviteData, { rejectWithValue }) => {
        try {
            const response = await apiClient.post('/clinics/clinic_invite', inviteData);
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || 'فشل في إرسال الدعوة');
        }
    }
);

const clinicDoctorsSlice = createSlice({
    name: 'clinicDoctors',
    initialState: {
        doctors: [],
        pagination: null,
        loading: false,
        inviting: false,
        error: null,
        success: null,
    },
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
        clearSuccess: (state) => {
            state.success = null;
        },
    },
    extraReducers: (builder) => {
        builder
            // Fetch Clinic Doctors
            .addCase(fetchClinicDoctors.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchClinicDoctors.fulfilled, (state, action) => {
                state.loading = false;
                const doctorsData = action.payload.result?.data || action.payload.data || [];
                state.doctors = Array.isArray(doctorsData) ? doctorsData : [];
                state.pagination = action.payload.result?.pagination || action.payload.pagination;
            })
            .addCase(fetchClinicDoctors.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })

            // Invite Doctor
            .addCase(inviteDoctor.pending, (state) => {
                state.inviting = true;
                state.error = null;
            })
            .addCase(inviteDoctor.fulfilled, (state, action) => {
                state.inviting = false;
                state.success = action.payload.message || 'تم إرسال الدعوة بنجاح';
            })
            .addCase(inviteDoctor.rejected, (state, action) => {
                state.inviting = false;
                state.error = action.payload;
            });
    },
});

export const { clearError, clearSuccess } = clinicDoctorsSlice.actions;
export default clinicDoctorsSlice.reducer;
